// extracted by css-extract-rspack-plugin
export default {"body":"SavedViewDialog-module__body__BqrHk","content":"SavedViewDialog-module__content__Uvmsi"};